import { useSort } from 'store/sort';
import { useFilters } from 'store/filters';
import { useCatalogPagination } from 'store/pagination';

const useResetAllFilters = () => {
  const resetFilters = useFilters((state) => state.resetFilters);
  const setSortState = useSort((state) => state.setSort);
  const setPaginationState = useCatalogPagination(
    (state) => state.setPagination,
  );

  const resetAllFilters = () => {
    resetFilters();
    setPaginationState(1);
    setSortState(null);
  };

  return { resetAllFilters };
};

export { useResetAllFilters };
